import type { Feature } from '@luna/gatekeeper';

export const cardFees: Feature = {
    enabled: true,
    _description: 'Displays card fees feature card in the card settings page',
};
